/*Language selector*/
$(document)
    .ready(function () {
        $('.langSelector')
            .click(function () {
                $('.language-item').toggle();
                $('.lang-active').hide();

                // disable mobile scroll on input focus
                document.ontouchmove = function (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            });

        function attachLightboxCaption() {        
            var captionText = $('.fancybox-caption').text();
            var captionWrap = $('.fancybox-caption-wrap');
            var $currentImage = $('.fancybox-slide--current .fancybox-image-wrap');
            if ($currentImage.find('.custom-caption').length === 0 && captionText !== '' && captionWrap.css('visibility') != 'hidden') {
                $currentImage.append('<div class="custom-caption">' + captionText + '</div>');
                console.log(captionText)
            } else {
                $('.custom-caption').detach();
            }
        }

        if ($('.illustrations-column').length > 0) {
            var $galleryItems = [];
            var $leftCol = $('.illustrations-column')
                .eq(0)
                .find('.illustration-item');
            var $rightCol = $('.illustrations-column')
                .eq(1)
                .find('.illustration-item');

            $leftCol.each(function (index, value) {
                $galleryItems.push(value);
                if ($rightCol[index]) {
                    $galleryItems.push($rightCol[index]);
                }
            });

            $('.illustration-item').on('click', function () {
                $.fancybox
                    .open($galleryItems, {
                        hash: false,
                        //arrows: false,
                        afterShow: function () {
                            attachLightboxCaption();
                        },
                        slideShow: {
                            autoStart: false,
                            speed: 3000
                        },
                        buttons: [
                            //"zoom",
                            //"share",
                            //"slideShow",
                            //"fullScreen",
                            //"download",
                            //"thumbs",
                            "close"
                          ],  

                    }, $($galleryItems).index(this));
                return false;
            });

        }

        // IE check => unset height on home banner
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            $('.fullscreen-bg__video').css('height', 'auto');
            console.log('executed');
        }
    });

/*Show/hide search input*/
$(document).ready(function () {
    $('.btn-search')
        .click(function () {
            $('#mainSearchBox').toggle();
            $('main').trigger('click');
        });
    $('#mainSearchBoxClose').click(function () {
        $('#mainSearchBox').hide();
    });
});

/*Mobile nav*/
$(document).ready(function () {
    var mobile,
        desktop;

    function getArrows() {      
        $('#menuElem > li > ul')
            .closest('li')
            .append("<button type='button' class='zatisi-down-open-big mob-nav-arrow'></div>");
    }

    function removeArrows() {
        $('#menuElem > li > ul')
            .closest('li')
            .children('a')
            .removeClass('zatisi-right-open-big');
        $('#menuElem > li > ul')
            .closest('li')
            .children('a')
            .removeClass('zatisi-down-open-big');
    }

    if ($('.nav-button').is(':visible')) {
        mobile = true;

        getArrows();
        $('#menuElem > li a')
            .siblings('ul')
            .addClass('show');
        //$('#menuElem > li ul').siblings('a').addClass('zatisi-down-open-big');
    } else {
        mobile = false;
    }

    function openNav() {
        $('html, body').addClass('noscroll');
        $('#nav-toggle-button').addClass('active');
        $('header .flex-header.wrapper-inner').addClass('move-left');
    };

    function closeNav() {
        $('html, body').removeClass('noscroll');
        $('#nav-toggle-button').removeClass('active');
        $('header .flex-header.wrapper-inner').removeClass('move-left');

    };

    $('#nav-toggle-button').click(function () {

        if ($(this).hasClass('active')) {
            // $('html, body').removeClass('noscroll');
            closeNav();
        } else {
            // $('html, body').addClass('noscroll');
            openNav();
        }       

    });

    // var smoothScroll = new SmoothScroll('a[href="#"]');

    $('.nav-homepage a').on('click', function () {
        $('body, html').removeClass('noscroll');
    });

    $('main, footer').click(function () {
        if ($(this).hasClass('move-left')) {       
            closeNav();
        }
    });

    $('.menu-wrapper a').click(function (e) {
        if (window.innerWidth < 980) {          
            closeNav();
        }     
    });

    $(".mob-nav-arrow").click(function () {
        $(this)
            .siblings("ul")
            .toggleClass("show");
        $(this).toggleClass('zatisi-right-open-big');
        $(this).toggleClass('zatisi-down-open-big');
    });

    if (mobile) {
        $(".mob-nav-arrow")
            .siblings("ul")
            .toggleClass("show");
        $(".mob-nav-arrow").toggleClass('zatisi-right-open-big');
        $(".mob-nav-arrow").toggleClass('zatisi-down-open-big');
    }

    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);

    var xDown = null;
    var yDown = null;

    function handleTouchStart(evt) {
        xDown = evt.touches[0].clientX;
        yDown = evt.touches[0].clientY;
    };

    function handleTouchMove(evt) {
        if (!xDown || !yDown) {
            return;
        }

        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;

        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
                /* left swipe */
            } else {
                closeNav();
            }
        } else {
            if (yDiff > 0) {
                /* up swipe */
            } else {
                /* down swipe */
            }
        }
        /* reset values */
        xDown = null;
        yDown = null;
    };
    $(window).resize(function () {
        if ($('.nav-button').is(':visible')) {
            if (!mobile) {
                //getArrows();
                mobile = true;

                $('#menuElem > li a')
                    .siblings('ul')
                    .addClass('show');
                //$('#menuElem > li ul').siblings('a').addClass('zatisi-down-open-big');
                $('#menuElem > li > ul')
                    .closest('li')
                    .children(".mob-nav-arrow")
                    .addClass("zatisi-down-open-big");
                $('#menuElem > li > ul')
                    .closest('li')
                    .children(".mob-nav-arrow")
                    .removeClass("zatisi-right-open-big");
            }
        } else {
            if (mobile) {
                $('#menuElem > li a')
                    .siblings('ul')
                    .removeClass('show');                
                mobile = false;

                $('.nav-button').removeClass('active');
                $('#nav-toggle-button')
                    .siblings('.menu-wrapper')
                    .removeClass('active');
                $('header .flex-header.wrapper-inner').removeClass('flex-start');
                $('main').removeClass('move-left');
                $('.nav-button').removeClass('move-left');
                $('footer').removeClass('move-left');
            }
        }
    });

});


/*ScrollMenu*/
$(document).ready(function () {
    $('.nav-homepage a')
        .click(function () {
            $('.nav-homepage a').removeClass('highlighted');
            $(this).addClass('highlighted');
        });

    /*Show locality selector*/
    $('.checkbox-select').click(function () {
        $(this).toggleClass('active');
        $(this)
            .next()
            .fadeToggle(200);

        if ($(".mobile-listlocations").hasClass("active")){
            $(".mobile-listlocations").removeClass("active");
            $(".mobile-openlocations").removeClass("active");
        }
    });
});

/*Show locality selector*/
$(document).ready(function () {
    window.sc
    var mob = false;

    function getReferencePaddingTop() {
        var heightScreen = $('.home-banner').outerHeight(true);
        var topBox = $('.banner-txt-box')
            .offset()
            .top;
        var heightBox = $('.banner-txt-box').outerHeight(true);
        var paddingTop = heightBox - (heightScreen - topBox);

        $('.ref-wrapp').css('padding-top', paddingTop);
    }

    if (window.innerWidth < 640) {
        if ($('.banner-txt-box').is(':visible')) {
            getReferencePaddingTop();
        }
        mob = true;
    }

    $(window)
        .resize(function () {
            if (window.innerWidth < 640) {
                if ($('.banner-txt-box').is(':visible')) {
                    getReferencePaddingTop();
                }
                mob = true;
            } else {
                if (mob) {
                    $('.ref-wrapp').css('padding-top', 88);
                    mob = false;
                }
            }
        });
});

/*References repeater load next - Reference detail*/
$(document).ready(function () {

    if ($(".services-references").eq(0).length) {
        var reference = $(".services-references").find(".ref-item")

        for (var i = 3; i < reference.length; i++) {
            $(".services-references")
                .find(".ref-item")
                .eq(i)
                .css({ "display": "none", "opacity": "0" });
        }

        var j = 3
        if (j >= reference.length) {          
            setTimeout(function () {
                $(".show-more")
                    .eq(0)
                    .css({ "display": "none" })
            }, 100);
        }
        $(".show-more")
            .click(function () {

                $(".services-references")
                    .find(".ref-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".services-references")
                    .find(".ref-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1
                $(".services-references")
                    .find(".ref-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".services-references")
                    .find(".ref-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1
                $(".services-references")
                    .find(".ref-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".services-references")
                    .find(".ref-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1
                if (j >= reference.length) {                  
                    setTimeout(function () {
                        $(".show-more")
                            .eq(0)
                            .css({ "display": "none" })
                    }, 100);
                }
            });
    }

})

/*Form select arrow animation & Date Picker*/
$(document).ready(function () {

    if ($(".drop-arrow input").eq(0).length) {

        $(".section-form :input:not(:hidden)")
            .each(function (i) {
                if (i == 0) {
                    $(this).attr('tabindex', 1);
                }
                if (i == 1) {
                    $(this).attr('tabindex', 4);
                }
                if (i == 2) {
                    $(this).attr('tabindex', 2);
                }
                if (i == 3) {
                    $(this).attr('tabindex', 5);
                }
                if (i == 4) {
                    $(this).attr('tabindex', 3);
                }
                if (i == 5) {
                    $(this).attr('tabindex', 6);
                }
                if (i == 6) {
                    $(this).attr('tabindex', 7);
                }
                if (i == 7) {
                    $(this).attr('tabindex', 8);
                }

                $(this)
                    .on('focus', function () {
                        $(this)
                            .parent()
                            .parent()
                            .find('.form-placeholder')
                            .eq(0)
                            .css({ "display": "none" })
                    });

                $(this).on('change', function () {
                    if ($(this).val().trim().length) {
                        $(this)
                            .parent()
                            .parent()
                            .find('.form-placeholder')
                            .eq(0)
                            .css({ "display": "none" })
                    }
                });

                $(this).on('blur', function () {
                    if (!$(this).val().trim().length) {
                        $(this)
                            .parent()
                            .parent()
                            .find('.form-placeholder')
                            .eq(0)
                            .css({ "display": "inline-block" })
                    }
                });
                var self = $(this)
                setTimeout(function () {
                    if (self.val() !== null && (self.val().trim().length) && i <= 6) {
                        self
                            .parent()
                            .parent()
                            .find('.form-placeholder')
                            .eq(0)
                            .css({ "display": "none" })
                    };
                }, 50);

            });

        //$(".drop-arrow input").eq(0).attr("placeholder", "vyberte termín akce *");
        var self1 = $(".drop-arrow input")
            .eq(0)
            .parent()
            .parent();
        $('.drop-arrow input').attr('readonly', true);
        $(".drop-arrow input")
            .eq(0)
            .focus(function () {
                self1.addClass('form-outline');
            });
        $(".drop-arrow input")
            .eq(0)
            .blur(function () {
                self1.removeClass('form-outline');
            });
        if ($('body').hasClass('ENUS')) {
            var dateLang = $.datepicker.regional["en-GB"]
        } else {
            var dateLang = $.datepicker.regional["cs"]
        }
        $
            .datepicker
            .setDefaults(dateLang);
        // $.datepicker.minDate = new Date.now();
        $(".drop-arrow input")
            .eq(0)
            .datepicker({
                onClose: function (date) {
                    self1.toggleClass('active');
                },
                beforeShow: function (date) {
                    self1.toggleClass('active');
                },
                minDate: '+1d'

            });
        $(".drop-arrow input")
            .eq(0)
            .change(function () {
                $(this).attr('value', $(".drop-arrow input").eq(0).val());
                $(this).text($(".drop-arrow input").eq(0).val())
                $(this).html($(".drop-arrow input").eq(0).val())

            });
    }
    if ($(".drop-arrow select").eq(0).length) {

        $(".drop-arrow select")
            .eq(0)
            .css("color", "#797d7f");
        $(".drop-arrow select")
            .eq(0)
            .change(function () {
                $(".drop-arrow select")
                    .eq(0)
                    .css("color", "#20282d");
            });
        var self = $(".drop-arrow select")
            .eq(0)
            .parent()
            .parent();

        self.click(function () {
            $(this).toggleClass('active');
        });

        $(".drop-arrow select")
            .eq(0)
            .on('focus', function () {
                self.addClass('form-outline');
            });

        $(".drop-arrow select")
            .eq(0)
            .on('blur', function () {
                self.removeClass('form-outline');
                self.removeClass('active');
            });

    }

});

/* Get query string from url*/
function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*Form select option for services*/
$(document)
    .ready(function () {

        if ($(".service-form").eq(0).length) {
            $(".section-form .drop-arrow select")
                .eq(0)
                .val($('#service-name-form').attr("data-name"));
        }

        if ($(".section-form").eq(0).length) {
            var service = getParameterByName('service');
            if (service != "" && !!service) {
                $(".section-form .drop-arrow select")
                    .eq(0)
                    .val(service);
            }
        }

    });

/*Set bottom padding for last button on page*/
$(document).ready(function () {

    if ($(".service-form").eq(0).length && $(".check-if-last-wrapper").eq(0).length) {

        setInterval(function () {
            if ($(".service-form").eq(0).css('display') == 'none' && !$(".check-if-last-wrapper").hasClass("last-wrapper")) {
                $(".check-if-last-wrapper")
                    .eq(0)
                    .addClass("last-wrapper")
            }

            if ($(".service-form").eq(0).css('display') != 'none' && $(".check-if-last-wrapper").hasClass("last-wrapper")) {
                $(".check-if-last-wrapper")
                    .eq(0)
                    .removeClass("last-wrapper")
            }

        }, 500);

    }
});

/*Scroll to form or redirect to form*/
function ifScroll(target, duration, service) {
    if ($(target).eq(0).css('display') == 'none') {

        window.location = window.location.origin + "/Nezavazna-poptavka.aspx?service=" + service

    } else {
        $('html, body').animate({
            scrollTop: (($(target).eq(0).offset().top - 56))
        }, duration)
    }
}

/*Rredirect to form*/
function goForm(locality) {
    window.location = window.location.origin + "/Nezavazna-poptavka.aspx?locality=" + locality
}

/*Newsletter validation text */
$(document)
    .ready(function () {

        if ($('.newsletter-wrapper').eq(0).length) {
            $('.newsletter-wrapper .form-control')
                .eq(0)
                .attr("placeholder", rscNews);
        }

        if ($('.newsletter-wrapper .ErrorMessage').eq(0).length) {
            $('.newsletter-wrapper .control-label')
                .eq(0)
                .text($('.newsletter-wrapper .ErrorMessage').eq(0).text())
            $('.newsletter-wrapper .control-label')
                .eq(0)
                .css("color", "#ed2f4e")
            $('.newsletter-wrapper .ErrorMessage')
                .eq(0)
                .text("")
            $('.newsletter-wrapper .form-control')
                .eq(0)
                .focus()

            scrollTo('.newsletter-wrapper', 0)
        }

        if ($('.nesletter-wrapper .InfoMessage').eq(0).length) {
            scrollTo('.nesletter-wrapper', 0)
        }

    });

/*Open google maps with adress*/
function findGoogle(locality) {
    window.open("https://www.google.cz/maps/place/" + locality, '_blank')
}

/*Scroll to target element*/
function scrollTo(target, duration, offset = 56) {

    if ($(target).eq(0).length) {

        $('html, body').animate({
            scrollTop: (($(target).eq(0).offset().top - offset))
        }, duration);

    }
}

/*Scroll to form after submit*/
$(document)
    .ready(function () {

        if ($('.InfoLabel').eq(0).length) {
            setTimeout(function () {
                scrollTo('.InfoLabel', 0)
            }, 400);
        }

        if ($('.EditingFormErrorLabel').eq(0).length) {
            setTimeout(function () {
                scrollTo('.section-form', 0)
            }, 400);
        }

    });

/*Show more search results*/
$(document).ready(function () {
    if ($(".no-result").eq(0).length) {
        var reference2 = $(".no-result").find(".result-item")

        for (var i = 5; i < reference2.length; i++) {
            $(".no-result")
                .find(".result-item")
                .eq(i)
                .css({ "display": "none", "opacity": "0" });
            $("#loadMoreCount2").text(i - 4)
        }

        var j = 5
        if (j >= reference2.length) {
            //$(".show-more").eq(0).animate({ opacity: '0' }, "normal");
            setTimeout(function () {
                $("#loadMoreButton2").css({ "display": "none" })
            }, 100);
        }
        $("#loadMoreButton2")
            .click(function () {

                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1;
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1;
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1;
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1;
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .css({ "display": "block" })
                $(".no-result")
                    .find(".result-item")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1;               
                $("#loadMoreCount2").text(reference2.length - j)
                if (j >= reference2.length) {
                    //$(".show-more").eq(0).animate({ opacity: '0' }, "normal");
                    setTimeout(function () {
                        $("#loadMoreButton2")
                            .eq(0)
                            .css({ "display": "none" })
                    }, 100);
                }
            });
    }
});

/*Whitebox position */
$(document).ready(function () {
    if ($(".white-box").eq(0).length) {
        var whiteBox = $(".white-box").eq(0)
        var bgImg = $(".bg-infinity-image").eq(0)
        if (window.innerWidth > 639) {
            if ((whiteBox.height()) < ((bgImg.height() / 100) * 40)) {
                var topPos = bgImg.height() - whiteBox.height()
                if (topPos < bgImg.height() / 1.3) {
                    topPos = bgImg.height() / 1.3
                }
                whiteBox.css({
                    'top': topPos + 'px'
                })
            }

        } else {
            var topPos = bgImg.height() - whiteBox.height()
            if (topPos < bgImg.height() / 1.5) {
                topPos = bgImg.height() / 1.5
            }
            whiteBox.css({
                'top': topPos + 'px'
            })
        }

        $(window)
            .resize(function () {

                if (window.innerWidth > 639) {
                    whiteBox.css("top", "");
                    if ((whiteBox.height()) < ((bgImg.height() / 100) * 40)) {
                        var topPos = bgImg.height() - whiteBox.height()
                        if (topPos < bgImg.height() / 1.3) {
                            topPos = bgImg.height() / 1.3
                        }
                        whiteBox.css({
                            'top': topPos + 'px'
                        })
                    }

                } else {
                    var topPos = bgImg.height() - whiteBox.height()
                    if (topPos < bgImg.height() / 1.5) {
                        topPos = bgImg.height() / 1.5
                    }
                    whiteBox.css({
                        'top': topPos + 'px'
                    })
                }
            })

    }
});

/*Our team - show subteam members*/
$(document).ready(function () {
    if ($('.subteam').is(':visible')) {
        $('.leaders-wrapper')
            .each(function () {
                var $this = $(this);
                if ($this.find('.subteam-member').length > 1) {
                    $this
                        .siblings('.hierarchy-tree')
                        .hide();
                    $this.addClass('more-leaders');
                }
            });

        $('.subordinate-wrapper').each(function () {
            var $this = $(this);
            if ($this.find('.subteam-member').length == 2) {
                $this
                    .siblings('.hierarchy-tree')
                    .addClass('branch2');
            }

            if ($this.find('.subteam-member').length == 1) {
                $this
                    .siblings('.hierarchy-tree')
                    .addClass('branch1');
            }
        });
    }

    $('.subteam-item')
        .click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this)
                    .parents('.subteam')
                    .find('.subteam-detail-bubble')
                    .hide();
                $(this)
                    .parents('.subteam')
                    .find('.subteam-members-wrapper')
                    .hide();
                $(this)
                    .parents('.subteam')
                    .find('.short-dark-line')
                    .show();
            } else {
                var id = $(this).attr('id');
                var filter = '[data-subteam="' + id + '"]';
                var parentElemLeftPos = $(this)
                    .parent()
                    .offset()
                    .left;
                var elementLeftPos = $(this)
                    .offset()
                    .left;
                var elementWidth = $(this).innerWidth();
                var pointerPosition = (elementLeftPos - parentElemLeftPos) + (elementWidth / 2);
                var element = $(this)
                    .parents('.subteam')
                    .find('.subteam-members-wrapper')
                    .filter(filter);

                $(this)
                    .parents('.subteam')
                    .find('.subteam-item')
                    .removeClass('active');
                $(this).addClass('active');
                $(this)
                    .parents('.subteam')
                    .find('.subteam-detail-bubble')
                    .show();
                $(this)
                    .parents('.subteam')
                    .find('.subteam-members-wrapper')
                    .hide();
                $(this)
                    .parents('.subteam')
                    .find('.subteam-members-wrapper')
                    .filter(filter)
                    .show();
                $(this)
                    .parents('.subteam')
                    .find('.pointer')
                    .css("left", pointerPosition);
                $(this)
                    .parents('.subteam')
                    .find('.short-dark-line')
                    .hide();
                $(this)
                    .parents('.subteam')
                    .find('.subteam-detail-bubble .short-dark-line')
                    .show();

                if (window.innerWidth <= 850) {
                    var elementBefore;
                    var order = $(this).data('order');

                    $(this)
                        .parents('.subteam')
                        .find('.subteam-detail-bubble .short-dark-line')
                        .hide();

                    if (order % 2 == 0) {
                        elementBefore = $(this);
                    } else {
                        order = order + 1;
                        elementBefore = $(this)
                            .parent()
                            .find(".subteam-item[data-order='" + order + "']");
                    }
                    var bubble = $(this)
                        .parents('.subteam')
                        .find('.subteam-detail-bubble');
                    elementBefore.after(bubble);
                    scrollTo(bubble, 500);
                } else {
                    scrollTo($(this).parent().next().eq(0), 500)
                }    
                
                // ie pollifill fix
                var resizeEvent = window.document.createEvent('UIEvents'); 
                resizeEvent .initUIEvent('resize', true, false, window, 0); 
                window.dispatchEvent(resizeEvent);
            }
        });

    if (window.innerWidth <= 850) {
        var mob = true;
    } else {
        var mob = false;
    }

    $(window)
        .resize(function () {
            if (window.innerWidth > 850) {
                if (mob) {
                    var wrapper = $('.subteam-detail-bubble')
                        .parents('.subteam')
                        .children('.subteam-wrapper');
                    var bubble = $('.subteam-detail-bubble');
                    wrapper.after(bubble);
                    mob = false;
                }
            } else {
                if (!mob) {
                    mob = true;
                    $('.subteam-detail-bubble').hide();
                    $('.subteam-item').removeClass('active');
                }
            }
        });
});

/* Calc search items */
$(document).ready(function () {
    if ($('.searchresults-wrapper').is(":visible")) {
        var count_elements = $('.result-item').length;

        $("#countResults").text(count_elements);
    }
});

// filtrovani a donacitani
$(function () {

    $(window)
        .resize(function () {
            if (window.innerWidth <= 770) {
                $('header').removeClass('scroll-header');
            } else {
                scrollMenu();
            }
        });

    function scrollMenu() {
        var scroll = $(window).scrollTop();
        var innerHeight = window.innerHeight;
        var height = innerHeight - innerHeight / 2;
        if ((scroll > height) && !($('header').hasClass('scroll-header'))) {
            $('header').addClass('scroll-header');
        } else {
            if (scroll < height) {
                $('header').removeClass('scroll-header');
            }
        }
    }
    scrollMenu();

    // requestAnimationFrame based on browser

    var sr = ScrollReveal({
        reset: true,
        distance: '15px',
        duration: 600,
        origin: 'left',
        scale: 0.95,
        opacity: 0.75,
        easing: 'ease-out'
    });
    if (document.querySelector('.stripe-item-image')) {
        sr.reveal('.stripe-item-image');
    }

    var mob;
    var rellax;

    if (window.innerWidth > 850 && document.querySelector('.stripe-item-txt')) {
        rellax = new Rellax('.stripe-item-txt', { center: true });
        mob = false;
    } else {
        mob = true;
    }

    function isOnScreen(elem) {
        // if the element doesn't exist, abort
        if ($(elem).length === 0) {
            return;
        }
        var $window = jQuery(window)
        var viewport_top = $window.scrollTop()
        var viewport_height = $window.height()
        var viewport_bottom = viewport_top + viewport_height
        var $elem = jQuery(elem)
        var top = $elem
            .offset()
            .top
        var height = $elem.height()
        var bottom = top + height

        return (top >= viewport_top && top < viewport_bottom) || (bottom > viewport_top && bottom <= viewport_bottom) || (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
    }

    function moveElement(xpos, ypos, el, start, end) {
        if (ypos < end && ypos > start) {
            var relativeYPos = ypos - start;
            el.style.transform = 'translate3d(' + xpos + ',' + relativeYPos + 'px,0)';          
        }
    }

    var xScrollPos;
    var yScrollPos;
    var endOfScroll = 1500;
    var food1 = document.querySelector('.food1');
    var food2 = document.querySelector('.food2');
    var food3 = document.querySelector('.food3');
    var food4 = document.querySelector('.food4');
    var banner = document.querySelector('.home-banner');
    var scrollBefore;

    var requestFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame;
   
    if (requestFrame) {
        if (/rv:11.0/i.test(navigator.userAgent)) {
            $(window)
                .scroll(function (event) {
                    if (window.innerWidth > 770) {
                        scrollMenu();
                    }
                    if (isOnScreen('.dark-wrapper')) {
                        startCounting();
                    }
                });
        } else {
            if (window.innerWidth > 1400) {
                scrollLoop();
            } else if (window.innerWidth <= 1399) {
                scrollLoopLaptop();
            }
        }
    }

    function scrollLoop() {
        yScrollPos = window.scrollY;
        if (scrollBefore == yScrollPos) {
            requestFrame(scrollLoop);
            return false;
        } else {
            scrollBefore = yScrollPos;
            scrollMenu();
            if (isOnScreen('.dark-wrapper')) {
                startCounting();
            }

        }
        requestFrame(scrollLoop);
    }
    function scrollLoopLaptop() {
        yScrollPos = window.scrollY;
        scrollMenu();
        if (isOnScreen('.dark-wrapper')) {
            startCounting();
        }
        requestFrame(scrollLoopLaptop);
    }

    if (window.innerWidth < 980) {
        var $selectToFocus = $('.drop-arrow select');
        var $nextInputGroup = $selectToFocus
            .closest('.required-input')
            .next()
            .next();
        $selectToFocus.on('focus', function () {
            $nextInputGroup.addClass('hidden');
        })
            .on('blur', function () {
                $nextInputGroup.removeClass('hidden');
                $('html, body').animate({
                    scrollTop: '-=100'
                }, 300);
            });
    }

    'use strict';

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function (Constructor, protoProps, staticProps) {
            if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
            if (staticProps)
                defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            }
            return arr2;
        } else {
            return Array.from(arr);
        }
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    $(window)
        .resize(function () {
            if (window.innerWidth <= 850) {
                if (!mob) {
                    //destroy on mobile
                    mob = true;
                    if (rellax) {
                        rellax.destroy();
                    }
                    setTimeout(function () {
                        removeTransforms();
                    }, 1000);
                }
            } else {
                if (mob) {
                    //init on desktop
                    mob = false;
                    if (document.querySelector('.stripe-item-txt')) {
                        rellax = new Rellax('.stripe-item-txt', { center: true });
                    }
                }
            }
        });

    function removeTransforms() {
        $('.stripe-item-txt, .food, .food3').css('transform', 'translate3d(0, 0, 0px)');
    }

    // class for single location
    var Location = function () {
        function Location(element) {
            _classCallCheck(this, Location);

            this.element = element;
            this.capacity = element.getAttribute('data-capacity');
            this.exclusivity = element.getAttribute('data-exclusivity');
            this.title = element.getAttribute('data-title');
            this.url = element.getAttribute('data-url');
            this.outdoor = element.getAttribute('data-outdoor');
            this.element.style.display = 'none';
        }

        _createClass(Location, [
            {
                key: 'show',
                value: function show() {
                    this.element.style.display = 'flex';
                }
            }, {
                key: 'hide',
                value: function hide() {
                    this.element.style.display = 'none';
                }
            }
        ]);

        return Location;
    }();

    // Filter UTIL functions
    function getLocationsURLQuery() {
        const url = new URL(window.location.href)
        return url.searchParams.get('location-filter')
    }

    function removeLocationsURLQuery() {
        const url = new URL(window.location.href)
        url.searchParams.delete('location-filter')
        window.history.replaceState(null, null, url)
    }

    function addLocationsURLQuery(locationFilterId) {
        const url = new URL(window.location.href)
        url.searchParams.append('location-filter', locationFilterId)
        window.history.replaceState(null, null, url)
    }

    // create locations array => map to class

    var locations = []
        .concat(_toConsumableArray(document.querySelectorAll('.location-wrapper')))
        .map(function (location) {
            return new Location(location);
        });


    // number of items loaded in one go (on load and when loadMoreButton is clicked)
    var itemsToShow = 4;

    // temp variables
    var currentState = void 0;
    var toBeLoaded = void 0;
    var toBeLoadedCount = void 0;
    var lastChecked = void 0;
    var firstTimeFiltering = true;
    var selectedCheckboxWidth = void 0;

    // it's called when filter option is clicked
    var filter = function filter(sender) {
        selectedCheckboxWidth = sender.parentElement.offsetWidth;
        locations.map(function (el) {
            return el.hide();
        });
        if (sender.id === 'all') {
            filterAll(sender);
        } else if (sender.id === 'exclusive') {
            filterExclusive(sender);
        } else if (sender.id === 'outdoor') {
            filterOutdoor(sender);
        } else {
            filterLimit(sender);
        }
        updateCount();
        if (window.innerWidth > 850) {
            rellax.destroy();
            rellax = new Rellax('.stripe-item-txt', { center: true });
        }      
        $('.checkboxes-wrapper .checkbox-wrapper').removeClass('filter-selected');
      
        sender
            .parentElement
            .classList
            .add('filter-selected');
        if (lastChecked != sender) {
            lastChecked = sender;
            sr.sync();         
        }
    };

    var filteredItemsArea = document.querySelector('#locations-list');
    var filteredItemsOutput;
    if (window.innerWidth > 980) {
        filteredItemsOutput = document.querySelector('#locations-list .list-wrapper');
    } else {
        filteredItemsOutput = document.querySelector('.mobile-listlocations');
    }

    $('.mobile-openlocations')
        .on('click', function () {
            $(this).toggleClass('active');
            $('.mobile-listlocations').toggleClass('active');
        });

    // generates all currently filtered items as links into hidden box
    var generateFilteredItems = function generateFilteredItems(currentState) { 

        var output = '';
        var clonedState = currentState.slice(0);  
        
        // razeni podle abecedy
        // clonedState.sort(function (a, b) {
        //     if (a.title < b.title) {
        //         return -1
        //     } else if (a.title > b.title) {
        //         return 1
        //     }
        //     return 0;
        // });

        clonedState.map(function (location) {
                return output += '<a href=\'' + location.url + '\'>' + location.title + '</a>';
            });
        filteredItemsOutput.innerHTML = output;
    };

    // displays hidden box with filtered items
    var checkboxWrappers = document.querySelectorAll('.checkbox-wrapper');
    var showFilteredItems = function showFilteredItems() {      
        if (window.innerWidth > 980) {
            var selectedFilter = document.querySelector('.filter-selected');
            $('.checkbox-wrapper').on('click', function () {
                $('.locations-list').addClass('active');
            });
            $(document).on('mouseenter', '.filter-selected, .locations-list', function () {
                $('.locations-list').addClass('active');
            });
            $(document).on('mouseleave', '.filter-selected, .locations-list', function () {
                $('.locations-list').removeClass('active');
            });
        } else { }
    };

    var tether = void 0;
    // init tether box to selected checkbox
    var attachDropdown = function attachDropdown(selectedDropdown) {
        if (window.innerWidth > 980) {
            if (tether) {
                tether.destroy();
            }
            tether = new Tether({
                element: filteredItemsArea,
                target: selectedDropdown.parentElement,
                attachment: 'top left',
                targetAttachment: 'bottom left',
                offset: '0 0',
                constraints: [
                    {
                        pin: true,
                        to: 'scrollParent',
                        attachment: 'together'
                    }
                ]
            });
        }
    };

    // separate filter functions called by filter()
    var filterAll = function filterAll() {

        var sender = arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : filterCheckboxes[0];

        attachDropdown(sender);
        generateFilteredItems(locations);
        currentState = locations.filter(function (el, index) {
            return index < itemsToShow;
        });
        currentState.map(function (el, index) {
            if (index % 2 === 0) {
                el
                    .element
                    .classList
                    .add('odd');
                el
                    .element
                    .classList
                    .remove('even');
            } else {
                el
                    .element
                    .classList
                    .add('even');
                el
                    .element
                    .classList
                    .remove('odd');
            }
            return el;
        })
            .map(function (el) {
                el.show();
                return el;
            });
        toBeLoaded = locations.filter(function (el, index) {
            return index >= itemsToShow;
        })
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .element
                        .classList
                        .add('odd');
                    el
                        .element
                        .classList
                        .remove('even');
                } else {
                    el
                        .element
                        .classList
                        .add('even');
                    el
                        .element
                        .classList
                        .remove('odd');
                }
                return el;
            });
    };

    var filterExclusive = function filterExclusive() {
        var sender = arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : filterCheckboxes[filterCheckboxes.length - 1];

        currentState = locations.filter(function (el) {
            return el.exclusivity === 'True';
        });
        attachDropdown(sender);
        generateFilteredItems(currentState);
        currentState.filter(function (el, index) {
            return index < itemsToShow;
        })
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .element
                        .classList
                        .add('odd');
                    el
                        .element
                        .classList
                        .remove('even');
                } else {
                    el
                        .element
                        .classList
                        .add('even');
                    el
                        .element
                        .classList
                        .remove('odd');
                }
                return el;
            })
            .map(function (el) {
                el.show();
                return el;
            });
        toBeLoaded = locations.filter(function (el) {
            return el.exclusivity === 'True';
        })
            .filter(function (el, index) {
                return index >= itemsToShow;
            })
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .element
                        .classList
                        .add('odd');
                    el
                        .element
                        .classList
                        .remove('even');
                } else {
                    el
                        .element
                        .classList
                        .add('even');
                    el
                        .element
                        .classList
                        .remove('odd');
                }
                return el;
            });
    };

    var filterOutdoor = function filterOutdoor() {
        var sender = arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : filterCheckboxes[filterCheckboxes.length - 1];

        currentState = locations.filter(function (el) {
            return el.outdoor === 'True';
        });
        attachDropdown(sender);
        generateFilteredItems(currentState);
        currentState.filter(function (el, index) {
            return index < itemsToShow;
        })
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .element
                        .classList
                        .add('odd');
                    el
                        .element
                        .classList
                        .remove('even');
                } else {
                    el
                        .element
                        .classList
                        .add('even');
                    el
                        .element
                        .classList
                        .remove('odd');
                }
                return el;
            })
            .map(function (el) {
                el.show();
                return el;
            });
        toBeLoaded = locations.filter(function (el) {
            return el.outdoor === 'True';
        })
            .filter(function (el, index) {
                return index >= itemsToShow;
            })
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .element
                        .classList
                        .add('odd');
                    el
                        .element
                        .classList
                        .remove('even');
                } else {
                    el
                        .element
                        .classList
                        .add('even');
                    el
                        .element
                        .classList
                        .remove('odd');
                }
                return el;
            });
    };

    var filterLimit = function filterLimit(sender) {
        currentState = locations.filter(function (el) {
            return el.capacity === sender.id;
        });
        attachDropdown(sender);
        generateFilteredItems(currentState);
        currentState.filter(function (el, index) {
            return index < itemsToShow;
        })
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .element
                        .classList
                        .add('odd');
                    el
                        .element
                        .classList
                        .remove('even');
                } else {
                    el
                        .element
                        .classList
                        .add('even');
                    el
                        .element
                        .classList
                        .remove('odd');
                }
                return el;
            })
            .map(function (el) {
                el.show();
                return el;
            });
        toBeLoaded = locations.filter(function (el) {
            return el.capacity === sender.id;
        })
            .filter(function (el, index) {
                return index >= itemsToShow;
            })
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .element
                        .classList
                        .add('odd');
                    el
                        .element
                        .classList
                        .remove('even');
                } else {
                    el
                        .element
                        .classList
                        .add('even');
                    el
                        .element
                        .classList
                        .remove('odd');
                }
                return el;
            });
    };

    // load more button shows next n items based on itemsToShow var, also updates
    // values of toBeLoaded
    var loadMoreButton = document.getElementById('loadMoreButton');
    if (loadMoreButton) {
        loadMoreButton
            .addEventListener('click', function () {
                toBeLoaded
                    .filter(function (el, index) {
                        return index < itemsToShow;
                    })
                    .map(function (el) {
                        $(el.element)
                            .find('img')
                            .trigger('unveil');
                        el.show();
                        $(el.element)
                            .find('img')
                            .trigger('unveil');
                    });
                if (toBeLoaded.length > itemsToShow) {
                    toBeLoaded = toBeLoaded.filter(function (el, index) {
                        return index >= itemsToShow;
                    });
                } else {
                    toBeLoaded = [];
                }
                updateCount();
                rellax.destroy();
                rellax = new Rellax('.stripe-item-txt', { center: true });
                sr.sync();
            });
    }

    // it's called when count of toBeLoaded items changes
    var updateCount = function updateCount() {
        toBeLoadedCount = toBeLoaded.length;
        if (toBeLoadedCount > 0) {
            loadMoreCount.innerHTML = toBeLoadedCount;
            loadMoreButton.style.display = 'inline-block';
        } else {
            loadMoreButton.style.display = 'none';
        }
    };
    if (loadMoreButton) {
        var _loadMoreCount = loadMoreButton.querySelector('#loadMoreCount');
    }

    // handle click on checkboxes, only one option at time (for now)
    // FILTER LISTENER
    var filterCheckboxes = [].concat(_toConsumableArray(document.querySelectorAll('.checkbox-wrapper input')));
    filterCheckboxes.map(function (checkbox) {
        checkbox
            .addEventListener('click', function (e) {
                if (!e.target.checked) {
                    e.target.checked = true;
                }
                filterCheckboxes
                    .map(function (checkbox) {
                     
                        if (checkbox != e.target) {
                            checkbox.checked = false;
                        }                      
                    });

                removeLocationsURLQuery();
                addLocationsURLQuery(e.target.id);
                sessionStorage.setItem('filter', e.target.id);
                filter(e.target);
                if (window.innerWidth < 990) {
                    var select = document.querySelector('#lokality .checkbox-select.active');
                    select.textContent = e.target.nextElementSibling.textContent;
                    select.click();
                }
            });
        return checkbox;
    });

    if (loadMoreButton && !getLocationsURLQuery()) {
        sessionStorage.setItem('filter', 'all');
        filterAll();
        // filter($('#all')[0]);
        updateCount();
    }

    // fix reference left X right
    var distributeClasses = function distributeClasses() {
        []
            .concat(_toConsumableArray(document.querySelectorAll('.ref-wrapp .stripe-item-wrapper')))
            .map(function (el, index) {
                if (index % 2 === 0) {
                    el
                        .classList
                        .add('odd');
                } else {
                    el
                        .classList
                        .add('even');
                }
            });
    };
    showFilteredItems();
    distributeClasses();
   
    var options = {
        useEasing: true,
        useGrouping: true,
        separator: ' ',
        decimal: ','
    };
    var wasCounted = false;

    function startCounting() {
        if (!wasCounted) {
            wasCounted = true;
            var c1 = new CountUp('number1', 0, parseFloat(countNum1), 0, 2, options);
            var c2 = new CountUp("number2", 0, parseFloat(countNum2), 1, 2, options);
            var c3 = new CountUp("number3", parseFloat(countNum3) - 5000, parseFloat(countNum3), 0, 2, options);
            c1.start();
            c2.start();
            c3.start();
        }
    }

    /*References repeater load next - Homepage*/

    if ($(".ref-wrapp").eq(0).length) {
        var reference1 = $(".ref-wrapp").find(".stripe-item-wrapper")

        for (var i = 3; i < reference1.length; i++) {
            $(".ref-wrapp")
                .find(".stripe-item-wrapper")
                .eq(i)
                .css({ "display": "none", "opacity": "0" });
            $("#loadMoreCount1").text(i - 2)
        }

        var j = 3
        if (j >= reference1.length) {
            //$(".show-more").eq(0).animate({ opacity: '0' }, "normal");
            setTimeout(function () {
                $("#loadMoreButton1").css({ "display": "none" })
            }, 100);
        }
        $("#loadMoreButton1")
            .click(function () {

                $(".ref-wrapp")
                    .find(".stripe-item-wrapper")
                    .eq(j)
                    .css({ "display": "flex" })
                $(".ref-wrapp")
                    .find(".stripe-item-wrapper")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1
                $(".ref-wrapp")
                    .find(".stripe-item-wrapper")
                    .eq(j)
                    .css({ "display": "flex" })
                $(".ref-wrapp")
                    .find(".stripe-item-wrapper")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1
                $(".ref-wrapp")
                    .find(".stripe-item-wrapper")
                    .eq(j)
                    .css({ "display": "flex" })
                $(".ref-wrapp")
                    .find(".stripe-item-wrapper")
                    .eq(j)
                    .animate({
                        opacity: '1'
                    }, "normal");
                j += 1
                if (!mob) {
                    rellax.destroy();
                    rellax = new Rellax('.stripe-item-txt', { center: true });
                }
                scrollTo($(".ref-wrapp").find(".stripe-item-wrapper").eq(j - 3), 0)
                $("#loadMoreCount1").text(reference1.length - j)
                if (j >= reference1.length) {
                    //$(".show-more").eq(0).animate({ opacity: '0' }, "normal");
                    setTimeout(function () {
                        $("#loadMoreButton1")
                            .eq(0)
                            .css({ "display": "none" })
                    }, 100);
                }
                sr.sync();
                // distributeClasses();
            });
    }

    var storedFilter = sessionStorage.getItem('filter');
    if (storedFilter && !getLocationsURLQuery()) {
        if ($("#" + storedFilter).length == 0) {
            return;
        }
        filter($("#" + storedFilter)[0]);      
    }
    
    const query = getLocationsURLQuery();
    if (query) {
        if ($("#" + query).length == 0) {
            return;
        }
        $("#" + query)[0].checked = true;
        filter($("#" + query)[0]);
        const url = new URL(window.location.href)
        if (url.hash) {
            const elem = document.querySelector(url.hash)
            if (!elem) return;
            setTimeout(() => {
                elem.scrollIntoView({ behavior: 'smooth' });
            }, 2000)
        }
    }
});

/*Set padding top for gallery wrapper*/
$(document).ready(function () {

    function getPaddingTop() {

        var heightScreen = $('.detail-head').outerHeight(true);
        var topBox = $('.detail-head .white-box')
            .offset()
            .top;
        var heightBox = $('.detail-head .white-box').outerHeight(true);
        var paddingTop = heightBox - (heightScreen - topBox);

        $('.padd-top').css('padding-top', paddingTop);

    }

    if ($('.padd-top').is(":visible")) {
        if (($('.detail-head .white-box').offset().top + $('.detail-head .white-box').outerHeight(true)) > $('.detail-head').outerHeight(true)) {
            getPaddingTop();
        }
    }

    $(window)
        .resize(function () {
            if ($('.padd-top').is(":visible")) {
                setTimeout(function () {

                    if (($('.detail-head .white-box').offset().top + $('.detail-head .white-box').outerHeight(true)) > $('.detail-head').outerHeight(true)) {
                        getPaddingTop();
                    }

                }, 100);
            }
        });

});

/*Show gallery*/
$(document).ready(function () {
    $('.showGallery')
        .click(function (e) {
            e.preventDefault();
            $('.illustration-item:eq(0)').click();
        });
});

function goBack() {
    window
        .history
        .back();
}

/*Btn Back*/
$(document)
    .ready(function () {

        function getParameterByName(name, url) {
            if (!url)
                url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results)
                return null;
            if (!results[2])
                return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        if (document.location.search.length) {
            $('#btnBack').show();
        }

        $('#btnBack')
            .click(function (e) {
                goBack();
            });
    });

/*Subteam open when came with querystring*/
$(document).ready(function () {
    if ($(".subteam").is(":visible") && document.location.search.length) {
        var url = window.location.href;
        var QSvalue = "#" + url
            .split('?')[1]
            .split('=')[1];

        $(QSvalue).trigger('click');
    }
});

$(function () {
    if ($('.owl-carousel').length > 0) {
        var carousel = $('.owl-carousel').owlCarousel({
            loop: true,
            items: 1,
            nav: false,
            dots: false,
            autoHeight: true,
            // autoplay: true,
            autoplayTimeout: 4000,
            autoplaySpeed: 1400, 
            lazyLoad:true
        });
        var $next = $('#newsNext');
        var $prev = $('#newsPrev');
        $next.on('click', function () {
            carousel.trigger('next.owl.carousel', ['700']);
            console.log('next');
        });
        $prev.on('click', function () {
            carousel.trigger('prev.owl.carousel', ['700']);
        });

    }
    
    var links = $('#menuElem > li > a');
    links.on('click', function (e) {
        var langPrefixes = ['/cs-CZ/', '/cs-cz/', '/en-us/', '/en-US/'];
        if (langPrefixes.indexOf(window.location.pathname) == -1) {
            e.preventDefault();
            window.location.href = window.location.origin + $(this).attr('href');
        }
    });

});



$(function () {
    function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
    // load files programatically function
    var load = function () {
        function _load(tag) {
            return function (url) {
                return new Promise(function (resolve, reject) {
                    var element = document.createElement(tag);
                    var parent = 'body';
                    var attr = 'src';

                    element.onload = function () {
                        return resolve(url);
                    };
                    element.onerror = function () {
                        return reject(element.error);
                    };

                    switch (tag) {
                        case 'script':
                            element.async = true;
                            break;
                        case 'link':
                            element.type = 'text/css';
                            element.rel = 'stylesheet';
                            attr = 'href';
                            parent = 'head';
                    }

                    element[attr] = url;
                    document[parent].appendChild(element);
                });
            };
        }

        return {
            css: _load('link'),
            js: _load('script'),
            img: _load('img')
        };
    }();
    // pdfReader 

    // check if pdfReader assets are loaded
    var isPdfReaderLoaded = function isPdfReaderLoaded() {
        var basePathJs = '/RZAT/flipbook/';
        var scripts = document.querySelectorAll('script');
        var src = basePathJs + 'pdf.min.js';
        var isLoaded = false;
        isLoaded = [].concat(_toConsumableArray(scripts)).some(function (s) {
            return s.src.indexOf(src) > -1;
        });
        return isLoaded;
    };

    var pdfLightbox = void 0;
    // loads pdfReader assets and inits pdfReader
    var loadPdfWithReader = function loadPdfWithReader(pdf, id) {
        var basePathCss = '/RZAT/flipbook/';
        var basePathJs = '/RZAT/flipbook/';

        Promise.all([load.css(basePathCss + 'font-awesome.css'), load.css(basePathCss + 'flipbook.style.css'), load.js(basePathJs + 'three.min.js'), load.js(basePathJs + 'flipbook.webgl.min.js'), load.js(basePathJs + 'pdf.min.js'), load.js(basePathJs + 'pdf.worker.min.js'), load.js(basePathJs + 'flipbook.min.js')]).then(function (url) {
            console.log('loaded');
            var options = {
                pdfUrl: pdf,
                lightBox: true,
                lightBoxOpened: true,
                lightboxBackground: 'rgba(0,0,0,.85)',
            };
            $('#' + id).flipBook(options);
        }).catch(function (err) {
            return console.log(err);
        });
    };

    // inits pdfReader
    var loadPdfWithoutReader = function loadPdfWithoutReader(pdf, id) {
        var options = {
            pdfUrl: pdf,
            lightBox: true,
            lightBoxOpened: true,
            lightboxBackground: 'rgba(0,0,0,.85)',
        };
        $('#' + id).flipBook(options);
    };


    var pdfLinks = $('.pdf-launch')
    if (pdfLinks.length > 0) {
        pdfLinks.click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var pdf = $(this).attr('href');
            var id = $(this).attr('id');
            isPdfReaderLoaded() ? loadPdfWithoutReader(pdf, id) : loadPdfWithReader(pdf, id);
        })
    }

    if (document.querySelector(".FormPanel")) {
        Promise.all([
            load.js("/RZAT/phonenumber/libphonenumber.js")
        ]).then(() => {
            initNumberValidation();
        }).catch((e) => {
            console.log(e);
        });
    }
})

// Set utm cookies
$(document).ready(function() {

    function setNewCookie(name, val) {
        if($.cookie(name) !== val && val !== undefined) {
            $.cookie(name, val, {
                expires : 30,
                path    : '/',
             })
        }
    }

    function getQueryParams (qs) {
        qs = qs.split('+').join(' ');
    
        var params = {};
        var re = /[?&]?([^=]+)=([^&]*)/g;
        var tokens = re.exec(qs);
    
        while (tokens) {
            params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
            tokens = re.exec(qs);
        }
    
        return params;
    };
    
    var params = getQueryParams(window.location.search);
    setNewCookie('utm_content', params.utm_content);
    setNewCookie('utm_source', params.utm_source);
    setNewCookie('utm_medium', params.utm_medium);
    setNewCookie('utm_campaign', params.utm_campaign);
    setNewCookie('utm_term', params.utm_term);  


    $(".GDPR-detal-text").click(function () {
        var descr = $(this);
        var transpBlock = $('.show--opacity');
        if (descr.hasClass("opening")) return
        if (!descr.hasClass("open")) {
          var heightDescr = descr[0].scrollHeight;
          descr.css("max-height", heightDescr);
          transpBlock.addClass('transparent');
          descr.addClass("opening");
          setTimeout(() => {
            descr.addClass("open");
            $(".accept .error").addClass("open");
            transpBlock.addClass('none');
            descr.removeClass("opening");
          }, 500);
          $("#GDPRMore").addClass('none');
        } else {
          descr.css("max-height", "100px");
          transpBlock.removeClass('none transparent');
          $("#GDPRMore").removeClass('none');
          descr.addClass("opening");
          setTimeout(() => {
            descr.removeClass("open");
            $(".accept .error").removeClass("open");
            descr.removeClass("opening");
          }, 500);
        }
      });
})

function initNumberValidation() {
    // najit cislo a ulozit
    var phonefield = $(".phone-field");

    $(".FormButton").click(function (e) {
        validateNumber(phonefield.val(), e);

        if (clicked) {
            e.preventDefault();
        }
        clicked = true;
    });
};


clicked = false; 
function validateNumber(num, e) {
    const util = new libphonenumber.PhoneNumberUtil();
    let isValid;
    try {
        isValid = util.isValidNumber(util.parse(num));
    } catch (err) {
        isValid = false;
    }

    if (!isValid) {
        e.preventDefault();
        if ($(".EditingFormErrorLabel.error").length === 0) {
            var newItem = "<span class='EditingFormErrorLabel error'>" + errorphone + "</span>";
            $(".phone-dummy").append(newItem);
        }   
        scrollTo('.EditingFormErrorLabel.error', 500, 100);
    }
    else {
        $(".EditingFormErrorLabel.error").hide();
        clicked = false;
    }
}

/*homepage scroll*/
$(document).ready(function () {
    
    const windowWidth = window.innerWidth;

    function overrideHomeNav() {
        const homeLinks = [...document.querySelectorAll("#menuElem a")]
        .filter(link => link.getAttribute("href").includes("#"))
        .map(link => {
            link.addEventListener("click", e => {
            e.stopImmediatePropagation();
            e.preventDefault();
            console.log("tady");
            const id = link
                .getAttribute("href")
                .substring(link.getAttribute("href").indexOf("#") + 1);
            if (document.getElementById(id)) {if (id.toLowerCase() === "kontakt" || id.toLowerCase() === "contact") {
                    const igImgs = [...document.querySelectorAll("img.lazyload")];
                    igImgs.forEach(i => lazySizes.loader.unveil(i));
                    const distance = document.body.scrollHeight + 1000;
                    scrollIt(distance, 1500, "easeOutQuad");
                    setTimeout(
                        () => scrollIt(document.getElementById(id), 500, "linear"),
                        1500
                    );
                }
                else {
                    scrollToID(id);
                }
                if (windowWidth < 1024) toggleNav();
            }
            });
            return link;
        });
/*
        var logo;
        logo = document.querySelector(".logo");
        logo.addEventListener("click", e => {
        e.preventDefault();
        if (window.pageYOffset > 0) {
            scrollIt(0, 1500, "easeOutQuad", null);
            const loc = window.location;
            history.replaceState("", document.title, loc.pathname + loc.search);
        }
        });*/

        /*const homeLinkAbout = [...document.querySelectorAll("#menuElem a")].filter(
        link =>
            link.getAttribute("href") === "/en/" ||
            link.getAttribute("href") === "/cz/"
        )[0];
        homeLinkAbout.addEventListener("click", e => e.preventDefault());*/
    }

    function scrollToID(id) {
        scrollIt(document.getElementById(id), 1500, "easeOutQuad");
        window.location.hash = `#${id}`;
    }
    
    // if on homepage
    if (document.querySelector(".home-banner")) {  
        // override home hash navigation
        overrideHomeNav();
    }
});

function scrollIt(destination, duration = 300, easing = 'linear', callback) {
    const easings = {
      linear(t) {
        return t;
      },
      easeInQuad(t) {
        return t * t;
      },
      easeOutQuad(t) {
        return t * (2 - t);
      },
      easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      },
      easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic(t) {
        return --t * t * t + 1;
      },
      easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      },
      easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart(t) {
        return 1 - --t * t * t * t;
      },
      easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
      },
      easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
      },
      easeInOutQuint(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
      }
    };
  
    const start = window.pageYOffset;
    const startTime =
      'now' in window.performance ? performance.now() : new Date().getTime();
    const headerHeight = window.innerWidth > 1024 ? 88 : 60;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.getElementsByTagName('body')[0].clientHeight;
    // EDITED to fix 72px navbar
    const destinationOffset =
      typeof destination === 'number'
        ? destination
        : destination.offsetTop - headerHeight;
    const destinationOffsetToScroll = Math.round(
      documentHeight - destinationOffset < windowHeight
        ? documentHeight - windowHeight
        : destinationOffset
    );
  
    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, destinationOffsetToScroll);
      if (callback) {
        callback();
      }
      return;
    }
  
    function scroll() {
      const now =
        'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, (now - startTime) / duration);
      const timeFunction = easings[easing](time);
      window.scroll(0, Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start));
  
      if (Math.ceil(window.pageYOffset) === destinationOffsetToScroll) {
        if (callback) {
          callback();
        }
        return;
      }
  
      requestAnimationFrame(scroll);
    }
  
    scroll();
  }

  // popup 
  $(document).ready(function(){
    if (document.querySelector(".popup-overlay")) {    
    
        $(".popup-close-action, .popup-overlay").click(function(event) {
          event.preventDefault();
          $("body").removeClass("popup-active");
          window.sessionStorage.setItem("popupclose", "close");
        });
       
        if (window.sessionStorage.getItem("popupclose") != "close") {
          window.setTimeout(function() {
            $("body").addClass("popup-active");
          }, 1000);
        } else {
          $("body").removeClass("popup-active");
        }    
      };
  });